export const single="single/product"